query getDamageLossInventoryState($from: DateTime, $to: DateTime) {
	damageLossInventoryState(from: $from, to: $to) {
		...fullInventoryState
	}
}